import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpFaqCategory, HELP_FAQ_LIST } from './help-faq.constant';

@Component({
  standalone: true,
  selector: 'app-help',
  imports: [CommonModule],
  templateUrl: './help.component.html',
  styleUrl: './help.component.css',
})
export class HelpComponent {
  readonly helpFaqList: HelpFaqCategory[] = HELP_FAQ_LIST;

  // tracks which questions are expanded, keyed by "categoryKey:index" so multiple can stay open
  private readonly expandedQuestions = new Set<string>();

  // all categories start expanded by default
  private readonly expandedCategories = new Set<string>(HELP_FAQ_LIST.map((c) => c.key));

  scrollToCategory(categoryKey: string): void {
    this.expandedCategories.add(categoryKey);
    document.getElementById(categoryKey)?.scrollIntoView({ behavior: 'smooth' });
  }

  isCategoryExpanded(categoryKey: string): boolean {
    return this.expandedCategories.has(categoryKey);
  }

  toggleCategory(categoryKey: string): void {
    if (this.expandedCategories.has(categoryKey)) {
      this.expandedCategories.delete(categoryKey);
    } else {
      this.expandedCategories.add(categoryKey);
    }
  }

  isQuestionExpanded(categoryKey: string, questionIndex: number): boolean {
    return this.expandedQuestions.has(`${categoryKey}:${questionIndex}`);
  }

  toggleQuestion(categoryKey: string, questionIndex: number): void {
    const key = `${categoryKey}:${questionIndex}`;
    if (this.expandedQuestions.has(key)) {
      this.expandedQuestions.delete(key);
    } else {
      this.expandedQuestions.add(key);
    }
  }
}
